import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, catchError, map, throwError } from 'rxjs';
import { RoleViewService } from './role-view.service';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
}


@Injectable({
  providedIn: 'root'
})
export class CreateProjectService {
  pathUrl = environment?.baseApiUrl + environment?.projectApiPath;
  private _selectedCollection: any;
  private _selectedProject: any;
  private _selectedsubCollection: any;
  private _selectedEmail: any;
  private _selectedDepartment: any;
  private _selectedFiles: any[] = [];
  private readonly _uploadedFiles: any[] = [];
  private _projectId: string | null = null;
  private _selectedTemplateId: any;
  private _selectedDepartmentIds: any;
  private _allTeamMembers: Record<string, any[]> = {};
  private _selectedAttachmentDepartmentIds: string[] = [];
  private _sourceProjectId: string | null = null;
  private _selectedSourceDocumentIds: string[] = [];

  userIdentifier = '';
  userUuid = '';
  userEmail = '';
  
  constructor(private readonly http: HttpClient,  private readonly roleViewService:RoleViewService) { 
    this.roleViewService.getUserName$().subscribe(name => {
      this.userIdentifier = name;
    });
    this.roleViewService.getUserUuid$().subscribe(uuid => {
      this.userUuid = uuid;
    });
    this.roleViewService.getUserEmail$().subscribe(email => {
      this.userEmail = email;
    });
  }
  updateFavoriteCollection(request: any): Observable<any> {
    const url = `${this.pathUrl}updateFavoriteCollection${environment?.proxy}`;
    const payloadRequest = {
      ...request,
      userUuid: this.userUuid
    };
    return this.http.post(url, payloadRequest, httpOptions)
      .pipe(map((response: any) => response));

  }

  fetchEmailTemplate(_userRole: string, _workDayId: string): Observable<any> {
    const url = `${this.pathUrl}fetchEmailTemplate${environment?.proxy}?workDayId=${this.userUuid}`;
    return this.http.get(url, httpOptions)
      .pipe(map((response: any) => response));
  }


  saveEmailTemplate( _workDayId: string, request: any): Observable<any> {
    const url = `${this.pathUrl}saveEmailTemplate${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${this.userUuid}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  sendEmailHandler(_workDayId: string, request: any): Observable<any> {
    const url = `${this.pathUrl}sendEmailHandler${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${this.userUuid}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  editEmailTemplate(_workDayId: string, request: any): Observable<any> {
    const url = `${this.pathUrl}editEmailTemplate${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${this.userUuid}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  saveEmailDrafts(_workDayId: string, request: any): Observable<any> {
    const url = `${this.pathUrl}saveEmailDrafts${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${this.userUuid}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  fetchCollections(_workDayId: string): Observable<any> {
    const url = `${this.pathUrl}fetchCollectionWithSubCol${environment?.proxy}?userIdentifier=${this.userIdentifier}&userUuid=${this.userUuid}`;
    return this.http.get(url, httpOptions)
      .pipe(map((response: any) => response));
  }

  saveSubCollections( request: any): Observable<any> {
    const url = `${this.pathUrl}saveSubCollectionNames${environment?.proxy}?userIdentifier=${this.userIdentifier}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  saveCollections(request: any): Observable<any> {
    const url = `${this.pathUrl}saveCollectionNames${environment?.proxy}?userIdentifier=${this.userIdentifier}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }
  saveCollectionWithSubCollections( request: any): Observable<any> {
    const url = `${this.pathUrl}saveColWithSubCollection${environment?.proxy}?userIdentifier=${this.userIdentifier}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }
  fetchCnraDetails(_workDayId: any): Observable<any> {
    const url = `${this.pathUrl}fetchCnraDetails${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${this.userUuid}`;
    return this.http.get(url, httpOptions)
      .pipe(map((response: any) => response));
  }

  // fetchDept(_workDayId: any): Observable<any> {
  //   const url = `${this.pathUrl}fetchDepartments${environment?.proxy}?userIdentifier=${this.userIdentifier}&userUuid=${this.userUuid}`;
  //   return this.http.get(url, httpOptions)
  //     .pipe(map((response: any) => response));
  // }
  fetchDepartments(_workDayId: any, page = 1, sortOrder: 'asc' | 'desc' = 'asc', searchText = ''): Observable<any> {
    const url = `${this.pathUrl}fetchDepartmentNames${environment?.proxy}`;
    const params = new HttpParams()
      .set('userIdentifier', this.userIdentifier)
      .set('userUuid', this.userUuid)
      .set('page', String(page))
      .set('sortOrder', sortOrder)
      .set('searchText', searchText.trim());
    return this.http.get(url, { ...httpOptions, params }).pipe(
      map((response: any) => response)
    );
  }

  fetchArchivedDepartmentsByProject(projectId: string): Observable<any> {
    const url = `${this.pathUrl}fetchArchDeptByProj${environment?.proxy}`;
    const params = new HttpParams()
      .set('userIdentifier', this.userIdentifier)
      .set('userUuid', this.userUuid)
      .set('projectId', projectId)
      .set('status', 'archived');
    return this.http.get(url, { ...httpOptions, params }).pipe(
      map((response: any) => response)
    );
  }

  fetchTeamMembers(departmentId: string, _workDayId: any): Observable<any> {
    const url = `${this.pathUrl}fetchTeamMemberNames${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${this.userUuid}&departmentId=${departmentId}`;
    return this.http.get(url).pipe(
      map((response: any) => response?.payload || [])
    );
  }

  documentFetchByProjectId(projectId: string, _workDayId: any): Observable<any> {
    const url = `${this.pathUrl}documentFetchByProjectId${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${this.userUuid}&projectId=${projectId}`;
    return this.http.get(url).pipe(
      map((response: any) => response?.payload || [])
    );
  }

  updateFavoriteDepartment(request: { departmentId: string; updatedBy: string }): Observable<any> {
    const url = `${this.pathUrl}updateFavoriteDepartment${environment?.proxy}?userIdentifier=${this.userIdentifier}`;
    const payloadRequest = {
      ...request,
      userUuid: this.userUuid
    };
    return this.http.post(url, payloadRequest, httpOptions).pipe(
      map((response: any) => response),
      catchError(this.handleError.bind(this))
    );
  }

  saveTeammemberDetails( _workDayId: string, request: any): Observable<any> {
    const url = `${this.pathUrl}saveTeamMemberNames${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${this.userUuid}`
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  fetchCustomDepartmentNames(status: string): Observable<any> {
    const url = `${this.pathUrl}fetchCustomDepartmentNames${environment?.proxy}?userEmail=${this.userEmail}&status=${status}&userUuid=${this.userUuid}`;
    return this.http.get(url, httpOptions)
      .pipe(map((response: any) => response));
  }

    saveCustomDepartment(request: any): Observable<any> {
    const url = `${this.pathUrl}saveCustomDepartment${environment?.proxy}?userIdentifier=${this.userIdentifier}`;
    const payload = {
      ...request,
      userIdentifier: this.userIdentifier,
      userUuid: this.userUuid,
    };
    return this.http.post(url, payload, httpOptions).pipe(
      map((response: any) => response),
      catchError(this.handleError.bind(this))
    );
  }

  updateCustomDepartment(request: any): Observable<any> {
    const url = `${this.pathUrl}updateCustomDepartment${environment?.proxy}?userIdentifier=${this.userIdentifier}`;
    const payload = {
      ...request,
      userIdentifier: this.userIdentifier,
      userUuid: this.userUuid,
    };
    return this.http.post(url, payload, httpOptions).pipe(
      map((response: any) => response),
      catchError(this.handleError.bind(this))
    );
  }

  deleteCustomDepartment(deptIds: { deptId: string; isdeleted: boolean }[]): Observable<any> {
    const url = `${this.pathUrl}deleteCustomDepartment${environment?.proxy}?userIdentifier=${this.userIdentifier}`;
    return this.http.post(url, { deptIds }, httpOptions).pipe(
      map((response: any) => response),
      catchError(this.handleError.bind(this))
    );
  }

  saveProjectDetails( request: any): Observable<any> {
    const url = `${this.pathUrl}saveProjectDetails${environment?.proxy}?userIdentifier=${this.userIdentifier}`;
    const payload = {
      ...request,
      userIdentifier: this.userIdentifier,
    };
    return this.http.post(url, payload, httpOptions)
      .pipe(map((response: any) => response));
  }

  uploadDocument(_workDayId: string, request: any): Observable<any> {
    const url = `${this.pathUrl}documentUpload${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${this.userUuid}`
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  collectionDocumentUpload(request: any): Observable<any> {
    const url = `${this.pathUrl}collectionDocumentUpload${environment?.proxy}?userIdentifier=${this.userIdentifier}`
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  deleteDocument(_workDayId: string, id: string): Observable<any> {
    const url = `${this.pathUrl}documentDelete${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${this.userUuid}&id=${id}`;
    return this.http.get(url, httpOptions)
      .pipe(map((response: any) => response));
  }

  collectionDocumentDelete(payload: any): Observable<any> {
    const url = `${this.pathUrl}collectionDocumentDelete${environment?.proxy}?userIdentifier=${this.userIdentifier}`;
    return this.http.post(url, payload, httpOptions)
      .pipe(map((response: any) => response));
  }

  readDocument(_workDayId: string, id: string): Observable<any> {
    const url = `${this.pathUrl}documentRead${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${this.userUuid}&id=${id}`;
    return this.http.get(url, httpOptions)
      .pipe(map((response: any) => response));
  }

  documentReadUrls(request: any): Observable<any> {
    const url = `${this.pathUrl}documentReadUrls${environment?.proxy}?userIdentifier=${this.userIdentifier}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  readCollectionDocument(id: string): Observable<any> {
    const url = `${this.pathUrl}documentRead${environment?.proxy}?userIdentifier=${this.userIdentifier}&cd_id=${id}`;
    return this.http.get(url, httpOptions)
      .pipe(map((response: any) => response));
  }

  fetchDocument(collectionId?: string): Observable<any> {
    let url = `${this.pathUrl}fetchCollectionDocumentDetails${environment?.proxy}?userIdentifier=${this.userIdentifier}`;
    if (collectionId) {
      url += `&collectionId=${collectionId}`;
    }
    return this.http.get(url, httpOptions)
      .pipe(map((response: any) => response));
  }

  uploadDocumentUser(_workDayId: string, request: any): Observable<any> {
    const url = `${this.pathUrl}documentUploadUser${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${_workDayId}`
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  setSelectedCollection(collection: any) {
    this._selectedCollection = collection;
    console.info("col", collection)
  }
  getSelectedCollection(): any {
    return this._selectedCollection;
  }

  setSelectedSubCollection(subcollection: any) {
    this._selectedsubCollection = subcollection;
  }
  getSelectedSubCollection(): any {
    return this._selectedsubCollection;
  }

  setSelectedProject(projectForm: any) {
    this._selectedProject = projectForm;
    console.info("project", projectForm)
  }
  getSelectedProject(): any {
    return this._selectedProject;
  }

  set setSelectedAttachmentDepartmentIds(deptIds: any[]) {
    this._selectedAttachmentDepartmentIds = deptIds;
  }
  get getSelectedAttachmentDepartmentIds(): string[] {
    return this._selectedAttachmentDepartmentIds;
  }

  setSelectedEmail(emailForm: any) {
    this._selectedEmail = emailForm;
  }
  getSelectedEmail(): any {
    return this._selectedEmail;
  }
  setSelectedTemplateId(templateId: any) {
    this._selectedTemplateId = templateId;
  }
  getSelectedTemplateId(): any {
    return this._selectedTemplateId;
  }
  setSelectedDepartment(deptForm: any) {
    this._selectedDepartment = deptForm;
  }
  getSelectedDepartment(): any {
    return this._selectedDepartment;
  }

  setSelectedDepartmentId(deptIds: any) {
    this._selectedDepartmentIds = deptIds;
  }
  getSelectedDepartmentId(): any {
    return this._selectedDepartmentIds;
  }

  // Store full allMembers map (by department) with selected flags
  setAllTeamMembers(allMembers: Record<string, any[]>): void {
    this._allTeamMembers = allMembers || {};
  }

  getAllTeamMembers(): Record<string, any[]> {
    return this._allTeamMembers;
  }

  setSelectedFiles(files: any[]) {
    this._selectedFiles = files;
    console.info("selected files", files)
  }
  getSelectedFiles(): any[] {
    return this._selectedFiles;
  }

  setProjectId(projectId: string | null) {
    this._projectId = projectId;
    console.info("projectId set:", projectId)
  }
  getProjectId(): string | null {
    return this._projectId;
  }

  // Source project being copied (only set during copy mode) so later steps can
  // list its documents for the user to copy into the new project.
  setSourceProjectId(sourceProjectId: string | null) {
    this._sourceProjectId = sourceProjectId;
  }
  getSourceProjectId(): string | null {
    return this._sourceProjectId;
  }

  setSelectedSourceDocumentIds(ids: string[]) {
    this._selectedSourceDocumentIds = ids || [];
  }
  getSelectedSourceDocumentIds(): string[] {
    return this._selectedSourceDocumentIds;
  }

  getWorkdayId(): string | null {
    const tokenStr = sessionStorage.getItem('CERT_IDTOKEN');
    if (!tokenStr) {
      return null;
    }
    const decoded: any = JSON.parse(tokenStr);
    const workdayId = decoded.WorkdayID ?? decoded.WorkdayId ?? decoded.workdayId;
    return workdayId ? workdayId.toString() : null;
  }

  // ===== Store Uploaded Files =====
  setUploadedFiles(file: any) {
    this._uploadedFiles.push(file);
  }
  getUploadedFiles(): any[] {
    return this._uploadedFiles;
  }

  // Add these methods to store and retrieve isChecked state
  setIsChecked(isChecked: boolean): void {
    localStorage.setItem('isChecked', JSON.stringify(isChecked));
  }

  getIsChecked(): boolean {
    const stored = localStorage.getItem('isChecked');
    return stored ? JSON.parse(stored) : false;
  }
  // Add these methods to store and retrieve isSubChecked state
  setIsSubChecked(isSubChecked: boolean): void {
    localStorage.setItem('isSubChecked', JSON.stringify(isSubChecked));
  }

  getIsSubChecked(): boolean {
    const stored = localStorage.getItem('isSubChecked');
    return stored ? JSON.parse(stored) : false;
  }

  // ===================================== Exception Handler ===========================================

  private handleError(error: HttpErrorResponse) {
    let errorMsg = '';
    if (error.error instanceof ErrorEvent) {
      //A client-side or network error occurred. Handle it accordingly.
      errorMsg = `An error occurred: ${error.error.message}`;
    } else {
      //The backend returned an unsuccessful response code.
      //The response body may contain clues as to what went wrong,
      errorMsg = `Backend returned code ${error.status}`;
    }
    //return an observable with a user-facing error message
    return throwError(() => new Error(errorMsg));
  }

}
